import type { FaireProductEntity } from "../../entity_types/product";

export const p_dm1zoue23c: FaireProductEntity = {
  token: "p_dm1zoue23c",
  type: "product",
  name: "Lip Balm, Pomegranate Peach",
  brandToken: "b_4uw0cexy",
  brandName: "Poppy & Pout",
  imageUrl:
    "https://cdn.faire.com/fastly/54512daef8ca9f8a123da2ea05a749c13bfc338cc34113c631fc531d9b8e44e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5c320e1f650042547051e3bc7b2af536c97648b2e1241100f0fbd48824779dd.png",
    "https://cdn.faire.com/fastly/c8c8be90ea2c26981f600b8c9ca2c14bd86005335d150f9ae2cf953913e52309.png",
    "https://cdn.faire.com/fastly/203395be54a3e621fa7c37f7d3741650f9c9348b0ffc1e7e50b55413df712351.jpeg",
    "https://cdn.faire.com/fastly/d720672d46e1cf704d711b0db11c831f2731abc8b3298725347091b72f852de1.png",
    "https://cdn.faire.com/fastly/3946397a6104ef57adae90dd5801490729c4c826eca2dce564fe87d83def2f5d.png",
    "https://cdn.faire.com/fastly/01328d8f135cda8047e96d60e1c779859c7d5d802e08cd1b9244d7162ca7a49f.png",
    "https://cdn.faire.com/fastly/c2cfc6c40f529f8ab937ae9360531573ee206274fa50ffaec04de722bb00a423.png",
    "https://cdn.faire.com/fastly/60b609326feab210fb7e3deee7c01e2dad331be01f3f673f78d7a809d58de17c.jpeg",
    "https://cdn.faire.com/fastly/bfbd4065db970c35e51e97bb14d6567aa7f5222645764c7fc5237c5c8c474773.jpeg",
  ],
  priceDollars: 4.98,
  description:
    "Don't forget to add a tester!\n\nOur Pomegranate Peach Lip Balm is just the right amount of sweet and fruity! Our loyal fans are obsessed with this new flavor combination. It's one of our best sellers for a reason!\n\n• 100% Natural Ingredients\nWe only use ingredients that are 100% natural. No parabens, phthalates, or petrolatum. Our coconut oil is USDA certified organic and we are Leaping Bunny certified cruelty-free!\n\n• Double the Balm\nOur lip balm tubes (0.3 oz) are twice the size of a standard lip balm.\n\n• About POPPY & POUT\nWe have been making our all-natural lip care products by hand in Idaho since 2014. Our lip balms are made from ethically sourced beeswax, organic coconut oil, and sunflower oil. We then add a hint of essential oils and/or natural flavor oils and a drop of Vitamin E. That's it! Simple ingredients for perfectly hydrated lips.\n\n• 100% Natural | Cruelty-Free (Leaping Bunny Certified) | Eco-Friendly",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:20:42.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
